"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateReadCache = void 0;
var client_1 = require("@apollo/client");
var kapi_1 = require("../../../shared/api/kapi");
var billing_1 = require("../../billing/utils/billing");
var useUpdateReadCache = function (accountId, sprn) {
    var cache = (0, client_1.useApolloClient)();
    // we need to update deeply nested data which is in a couple of arrays
    // data passed to cache needs to match structure of existing data
    // so read existing data, copy it and update then pass that to updateCache
    // we can't just use refetch since the data may not yet be available in Kapi
    // data from cache is immutable, so take a copy
    var cachedData = (0, billing_1.deepClone)(cache.readQuery({
        query: kapi_1.ApMeterReadsDocument,
        variables: { accountId: accountId },
    }));
    var updateReadCache = function (reading) {
        if (cachedData) {
            // find the right supply to add read
            var alteredAsp = cachedData.account.accountSupplyPoints.find(function (asp) { return asp.supplyPoint.sprn === sprn; });
            // add our new reading to list
            alteredAsp.meterReads.edges.push(reading);
            // save new read (along with all the existing query data) to cache
            cache.writeQuery({
                query: kapi_1.ApMeterReadsDocument,
                variables: { accountId: accountId },
                data: cachedData,
            });
        }
    };
    return updateReadCache;
};
exports.useUpdateReadCache = useUpdateReadCache;
